module.exports = __webpack_public_path__ + "static/img/伙伴客户-解放军301.ff2a44ff.png";